<div
    class="thumbnail"
    [ngStyle]="{ width: thumbSize.width + 'px', height: thumbSize.height + 'px' }"></div>
